var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import HonestFooter from '@digitools/honest-react/dist/lib/composites/Footer';
import Link from '@digitools/honest-react/dist/lib/components/Link';
import useTealium from '../../hooks/useTealium';
import { TEALIUM_EVENT } from '../../constants/tealiumConstants';
import Logo from '../../assets/new-tagline.svg';
import CookieConsent from './CookieConsent';
var FooterLink = HonestFooter.FooterLink;
var FooterLinks = /*#__PURE__*/memo(function () {
  var trackEvent = useTealium().trackEvent;
  return _jsxs(_Fragment, {
    children: [_jsx(FooterLink, {
      children: _jsx(Link, __assign({
        href: 'https://www.lfg.com/public/aboutus/companyoverview',
        target: '_blank',
        rel: 'noopener',
        "aria-label": "Go to Lincoln Financial's company overview page"
      }, {
        children: "About Lincoln Financial"
      }))
    }), _jsx(FooterLink, {
      children: _jsx(Link, __assign({
        href: 'https://www.lfg.com/privacy',
        target: '_blank',
        rel: 'noopener',
        "aria-label": "Go to Lincoln Financial's privacy page"
      }, {
        children: "Privacy"
      }))
    }), _jsx(FooterLink, {
      children: _jsx(Link, __assign({
        href: 'https://www.lfg.com/legal',
        target: '_blank',
        rel: 'noopener',
        "aria-label": "Go to Lincoln Financial's legal page"
      }, {
        children: "Legal"
      }))
    }), _jsx(FooterLink, {
      children: _jsx(Link, __assign({
        href: '/dental/terms-and-conditions',
        target: '_blank',
        rel: 'noopener',
        "aria-label": "Go to Lincoln Financial's terms and conditions page"
      }, {
        children: "Terms & Conditions"
      }))
    }), _jsx(FooterLink, {
      children: _jsx(Link, __assign({
        href: '/dental/accessibility',
        target: '_blank',
        rel: 'noopener',
        "aria-label": "Go to Lincoln Financial's accessibility page"
      }, {
        children: "Accessibility"
      }))
    }), _jsx(FooterLink, {
      children: _jsx(Link, __assign({
        href: 'https://www.lincolnfinancial.com/public/general/support/reportfraud/form',
        target: '_blank',
        rel: 'noopener',
        "aria-label": "Go to Lincoln Financial's report fraud page",
        onClick: function () {
          trackEvent({
            event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
            event_name: 'report fraud',
            event_type: TEALIUM_EVENT.EVENT_TYPE.FOOTER
          });
        }
      }, {
        children: "Report Fraud"
      }))
    })]
  });
});
var Footer = function () {
  var disclaimerText = 'Lincoln Financial is the marketing name for Lincoln National Corporation and its affiliates. Affiliates are separately responsible for their own financial and contractual obligations.';
  var lcn = 'LCN-7642076-021425';
  return _jsx(HonestFooter, {
    logo: Logo,
    links: FooterLinks,
    showSocialIcons: true,
    // @ts-ignore
    content: _jsxs(_Fragment, {
      children: [disclaimerText, _jsx(CookieConsent, {})]
    }),
    lcn: lcn
  });
};
export default Footer;